
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a/[articleSlug]",
      function () {
        return require("private-next-pages/a/[articleSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a/[articleSlug]"])
      });
    }
  